import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_label_list_hdr_RowClass} from '../../../dbschema';


export class CmsLabelListContainerModel extends BaseContainerModel {

  bl_cms_label_list_hdr: bl_cms_label_list_hdr_RowClass = new bl_cms_label_list_hdr_RowClass();
}
